import { isEmpty } from "../functions";

export enum EmisionStatus {
  EXTRACT_DATA = "extrayendo-datos",
  IN_VALIDATION_PROCESS = "cotejo",
  CREATING_REQUEST = "creando-solicitud",
  EMISSION_TEXT_VALIDATION = "emision-validacion-textos",
  EMISSION_PREVIEW_VALIDATION = "emision-valida-vista-previa",
  UPDATING_REQUEST = "actualizando-solicitud",
  EMISSION_MANUAL_VALIDATION_HOCELOT = "emision-validacion-manual-hocelot",
  EMISSION_DENIED_HOCELOT = "emision-validacion-denegada-hocelot",
  IN_EMISSION = "en-emision",
  EMISSION_FINISHED_PENDING_AUTHORIZATIONS = "emision-finalizada-autorizaciones-pendientes",
  EMISSION_FINISHED = "emision-finalizada",
  // Nuevos estatus agregados
  EMISSION_CREATING_BENEFICIARY = "emision-creando-beneficiario",
  EMISSION_UPLOADING_FILES = "emision-subiendo-archivos",
  EMISSION_UPDATING_REQUEST = "emision-actualizando-solicitud",
  EMISSION_CONSULTING_HOCELOT = "emision-consultando-hocelot",
  EMISSION_GENERATING_PREVIEW = "emision-generando-vista-previa",
  EMISSION_EVALUATING_AUTHORIZATIONS = "emision-evaluando-autorizaciones",
  EMISSION_GENERATING_AUTHORIZATIONS = "emision-generando-autorizaciones",
  // Estatus de error
  EMISSION_PRODUCT_NOT_EMISSIBLE = "emision-producto-no-emisible",
  ERROR_CREATING_REQUEST = "error-creando-solicitud",
  // Nuevos estatus de error agregados
  EMISSION_ERROR_CREATING_BENEFICIARY = "emision-error-creando-beneficiario",
  EMISSION_ERROR_UPLOADING_FILES = "emision-error-subiendo-archivos",
  EMISSION_ERROR_UPDATING_REQUEST = "emision-error-actualizando-solicitud",
  EMISSION_ERROR_CONSULTING_HOCELOT = "emision-error-consultando-hocelot",
  EMISSION_ERROR_GENERATING_PREVIEW = "emision-error-generando-vista-previa",
  EMISSION_ERROR_EVALUATING_AUTHORIZATIONS = "emision-error-evaluando-autorizaciones",
  EMISSION_ERROR_GENERATING_AUTHORIZATIONS = "emision-error-generando-autorizaciones",
  EMISSION_CONTINUE_IN_PUNTO_ASERTA = "continuada-por-siebel",
  EMISSION_VALIDATING_AUTHORIZATIONS = "emision-valida-autorizaciones",
  EMISSION_CANCEL = "solicitud-cancelada"
}

export interface EmisionState {
  message: string;
  isError: boolean;
  color: string;
}

export const emisionStates: Record<EmisionStatus, EmisionState> = {
  // Estados existentes con textos corregidos según versión final del documento
  [EmisionStatus.EXTRACT_DATA]: { message: 'Extrayendo datos', isError: false, color: '#92D050' },
  [EmisionStatus.IN_VALIDATION_PROCESS]: { message: 'En proceso', isError: false, color: '#92D050' },
  [EmisionStatus.CREATING_REQUEST]: { message: 'Creando solicitud', isError: false, color: '#00B0F0' },
  [EmisionStatus.EMISSION_TEXT_VALIDATION]: { message: 'En revisión agente', isError: false, color: '#00B0F0' },
  [EmisionStatus.EMISSION_PREVIEW_VALIDATION]: { message: 'En revisión agente', isError: false, color: '#00B0F0' },
  [EmisionStatus.UPDATING_REQUEST]: { message: 'Actualizando solicitud', isError: false, color: '#E599F7' },
  [EmisionStatus.EMISSION_MANUAL_VALIDATION_HOCELOT]: { message: 'Continuar en Punto Aserta', isError: false, color: '#92D050' },
  [EmisionStatus.EMISSION_DENIED_HOCELOT]: { message: 'Continuar en Punto Aserta', isError: true, color: '#92D050' },
  [EmisionStatus.IN_EMISSION]: { message: 'Emitiendo', isError: false, color: '#00B0F0' },
  [EmisionStatus.EMISSION_FINISHED_PENDING_AUTHORIZATIONS]: { message: 'Continuar en Punto Aserta', isError: false, color: '#92D050' },
  [EmisionStatus.EMISSION_FINISHED]: { message: 'Solicitud completa', isError: false, color: '#92D050' },
  [EmisionStatus.EMISSION_CREATING_BENEFICIARY]: { message: 'Creando beneficiario', isError: false, color: '#00B0F0' },
  [EmisionStatus.EMISSION_UPLOADING_FILES]: { message: 'Subiendo archivos', isError: false, color: '#00B0F0' },
  [EmisionStatus.EMISSION_UPDATING_REQUEST]: { message: 'Actualizando solicitud', isError: false, color: '#E599F7' },
  [EmisionStatus.EMISSION_CONSULTING_HOCELOT]: { message: 'Evaluando emisión', isError: false, color: '#92D050' },
  [EmisionStatus.EMISSION_GENERATING_PREVIEW]: { message: 'Generando previo', isError: false, color: '#00B0F0' },
  [EmisionStatus.EMISSION_EVALUATING_AUTHORIZATIONS]: { message: 'Evaluando autorización', isError: false, color: '#92D050' },
  [EmisionStatus.EMISSION_GENERATING_AUTHORIZATIONS]: { message: 'Generando autorización', isError: false, color: '#00B0F0' },
  [EmisionStatus.EMISSION_PRODUCT_NOT_EMISSIBLE]: { message: 'Producto no válido', isError: true, color: '#FF0000' },
  [EmisionStatus.ERROR_CREATING_REQUEST]: { message: 'Error creando solicitud', isError: true, color: '#FF0000' },
  [EmisionStatus.EMISSION_ERROR_CREATING_BENEFICIARY]: { message: 'Error creando beneficiario', isError: true, color: '#FF0000' },
  [EmisionStatus.EMISSION_ERROR_UPLOADING_FILES]: { message: 'Error subiendo archivos', isError: true, color: '#FF0000' },
  [EmisionStatus.EMISSION_ERROR_UPDATING_REQUEST]: { message: 'Error actualizando solicitud', isError: true, color: '#FF0000' },
  [EmisionStatus.EMISSION_ERROR_CONSULTING_HOCELOT]: { message: 'Error evaluando emisión', isError: true, color: '#FF0000' },
  [EmisionStatus.EMISSION_ERROR_GENERATING_PREVIEW]: { message: 'Error generando previo', isError: true, color: '#FF0000' },
  [EmisionStatus.EMISSION_ERROR_EVALUATING_AUTHORIZATIONS]: { message: 'Error evaluando autorización', isError: true, color: '#FF0000' },
  [EmisionStatus.EMISSION_ERROR_GENERATING_AUTHORIZATIONS]: { message: 'Error generando autorización', isError: true, color: '#FF0000' },
  [EmisionStatus.EMISSION_CONTINUE_IN_PUNTO_ASERTA]: { message: 'Continuar en Punto Aserta', isError: false, color: '#92D050' },
  [EmisionStatus.EMISSION_VALIDATING_AUTHORIZATIONS]: { message: 'En revisión agente', isError: false, color: '#92D050' },
  [EmisionStatus.EMISSION_CANCEL]: {message: "Emisión cancelada", isError: false, color: '#00B0F0'}
};

const primaryVariants: Partial<Record<EmisionStatus, "primary">> = {
  [EmisionStatus.EMISSION_PREVIEW_VALIDATION]: "primary",
  [EmisionStatus.EMISSION_TEXT_VALIDATION]: "primary",
  [EmisionStatus.EMISSION_EVALUATING_AUTHORIZATIONS]: "primary",
  [EmisionStatus.EMISSION_CONSULTING_HOCELOT]: "primary",
  [EmisionStatus.EXTRACT_DATA]: "primary",
  [EmisionStatus.CREATING_REQUEST]: "primary",
  [EmisionStatus.EMISSION_CREATING_BENEFICIARY]: "primary",
  [EmisionStatus.EMISSION_GENERATING_AUTHORIZATIONS]: "primary",
  [EmisionStatus.EMISSION_GENERATING_PREVIEW]: "primary",
  [EmisionStatus.EMISSION_UPLOADING_FILES]: "primary",
  [EmisionStatus.UPDATING_REQUEST]: "primary",
  [EmisionStatus.IN_EMISSION]: "primary",
}

const infoVariants: Partial<Record<EmisionStatus, "info">> = {
  [EmisionStatus.IN_VALIDATION_PROCESS]: "info",
  [EmisionStatus.EMISSION_VALIDATING_AUTHORIZATIONS]: "info",
}

const warningVariants: Partial<Record<EmisionStatus, "warning">> = {
  [EmisionStatus.EMISSION_CONTINUE_IN_PUNTO_ASERTA]: "warning",
  [EmisionStatus.EMISSION_DENIED_HOCELOT]: "warning",
  [EmisionStatus.EMISSION_MANUAL_VALIDATION_HOCELOT]: "warning",
  [EmisionStatus.EMISSION_FINISHED_PENDING_AUTHORIZATIONS]: "warning",

}

const errorVariants: Partial<Record<EmisionStatus, "error">> = {
  [EmisionStatus.EMISSION_PRODUCT_NOT_EMISSIBLE]: "error",
  [EmisionStatus.ERROR_CREATING_REQUEST]: "error",
  [EmisionStatus.EMISSION_ERROR_CREATING_BENEFICIARY]: "error",
  [EmisionStatus.EMISSION_ERROR_UPLOADING_FILES]: "error",
  [EmisionStatus.EMISSION_ERROR_UPDATING_REQUEST]: "error",
  [EmisionStatus.EMISSION_ERROR_CONSULTING_HOCELOT]: "error",
  [EmisionStatus.EMISSION_ERROR_GENERATING_PREVIEW]: "error",
  [EmisionStatus.EMISSION_ERROR_EVALUATING_AUTHORIZATIONS]: "error",
  [EmisionStatus.EMISSION_ERROR_GENERATING_AUTHORIZATIONS]: "error",
}

const successVariants: Partial<Record<EmisionStatus, "success">> = {
  [EmisionStatus.EMISSION_FINISHED]: "success",
}

export const emisionVariantsStates: Partial<Record<EmisionStatus, "primary" | "info" | "warning" | "error" | "success">> = {
  ...primaryVariants,
  ...infoVariants,
  ...warningVariants,
  ...errorVariants,
  ...successVariants,
};

// Estatus que indican que el proceso ha terminado (finales)
export const completedEmisionStatus = [
  EmisionStatus.EMISSION_MANUAL_VALIDATION_HOCELOT,
  EmisionStatus.EMISSION_DENIED_HOCELOT,
  EmisionStatus.EMISSION_FINISHED_PENDING_AUTHORIZATIONS,
  EmisionStatus.EMISSION_FINISHED,
  EmisionStatus.EMISSION_PRODUCT_NOT_EMISSIBLE,
  EmisionStatus.ERROR_CREATING_REQUEST,
];

export const finishedEmisionStatus = [  
  EmisionStatus.EMISSION_FINISHED,
  EmisionStatus.EMISSION_FINISHED_PENDING_AUTHORIZATIONS,
  EmisionStatus.EMISSION_DENIED_HOCELOT,
  EmisionStatus.EMISSION_MANUAL_VALIDATION_HOCELOT,
  EmisionStatus.EMISSION_PRODUCT_NOT_EMISSIBLE,
  EmisionStatus.EMISSION_CANCEL,
  EmisionStatus.EMISSION_CONTINUE_IN_PUNTO_ASERTA,
  EmisionStatus.CREATING_REQUEST,
  EmisionStatus.UPDATING_REQUEST,
];

// Estatus que indican éxito en el proceso
export const successEmisionStatus = [
  EmisionStatus.EMISSION_MANUAL_VALIDATION_HOCELOT, // Vuelve a ser éxito según documento final
  EmisionStatus.EMISSION_FINISHED_PENDING_AUTHORIZATIONS,
  EmisionStatus.EMISSION_FINISHED,
];

// Estatus que indican error en el proceso
export const errorEmisionStatus = [
  EmisionStatus.EMISSION_DENIED_HOCELOT,
  EmisionStatus.EMISSION_PRODUCT_NOT_EMISSIBLE,
  EmisionStatus.ERROR_CREATING_REQUEST,
  EmisionStatus.EMISSION_ERROR_CREATING_BENEFICIARY,
  EmisionStatus.EMISSION_ERROR_UPLOADING_FILES,
  EmisionStatus.EMISSION_ERROR_UPDATING_REQUEST,
  EmisionStatus.EMISSION_ERROR_CONSULTING_HOCELOT,
  EmisionStatus.EMISSION_ERROR_GENERATING_PREVIEW,
  EmisionStatus.EMISSION_ERROR_EVALUATING_AUTHORIZATIONS,
  EmisionStatus.EMISSION_ERROR_GENERATING_AUTHORIZATIONS,
];

export const editableEmisionStatus = [
  EmisionStatus.IN_VALIDATION_PROCESS,
  EmisionStatus.EMISSION_VALIDATING_AUTHORIZATIONS,
  EmisionStatus.EMISSION_TEXT_VALIDATION,
  EmisionStatus.EMISSION_PREVIEW_VALIDATION,
  EmisionStatus.EMISSION_FINISHED,
  EmisionStatus.EMISSION_VALIDATING_AUTHORIZATIONS
]

export const deleteEmisionStatus = [
  EmisionStatus.EMISSION_MANUAL_VALIDATION_HOCELOT,
  EmisionStatus.EMISSION_DENIED_HOCELOT,
  EmisionStatus.EMISSION_PRODUCT_NOT_EMISSIBLE,
  EmisionStatus.ERROR_CREATING_REQUEST,
  EmisionStatus.EMISSION_ERROR_CREATING_BENEFICIARY,
  EmisionStatus.EMISSION_ERROR_UPLOADING_FILES,
  EmisionStatus.EMISSION_ERROR_UPDATING_REQUEST,
  EmisionStatus.EMISSION_ERROR_CONSULTING_HOCELOT,
  EmisionStatus.EMISSION_ERROR_GENERATING_PREVIEW,
  EmisionStatus.EMISSION_ERROR_EVALUATING_AUTHORIZATIONS,
  EmisionStatus.EMISSION_ERROR_GENERATING_AUTHORIZATIONS,
];

/**
 * Estatus que permiten continuar en Punto Aserta
 */
export const continueInPuntoAsertaStatus = [
  EmisionStatus.EMISSION_TEXT_VALIDATION,
  EmisionStatus.EMISSION_ERROR_UPDATING_REQUEST,
  EmisionStatus.EMISSION_ERROR_UPLOADING_FILES,
  EmisionStatus.EMISSION_ERROR_GENERATING_PREVIEW,
  EmisionStatus.EMISSION_ERROR_EVALUATING_AUTHORIZATIONS,
  EmisionStatus.EMISSION_PREVIEW_VALIDATION,
  EmisionStatus.EMISSION_ERROR_GENERATING_AUTHORIZATIONS,
  EmisionStatus.EMISSION_PRODUCT_NOT_EMISSIBLE,
  EmisionStatus.EMISSION_ERROR_CONSULTING_HOCELOT,
  //EmisionStatus.EMISSION_VALIDATING_AUTHORIZATIONS
]

export const controlChangeEmisionStatus = [
  EmisionStatus.IN_VALIDATION_PROCESS,
  EmisionStatus.EMISSION_ERROR_CREATING_BENEFICIARY,
  EmisionStatus.EMISSION_TEXT_VALIDATION,
  EmisionStatus.EMISSION_PREVIEW_VALIDATION
];

// Función helper para verificar si un estatus es final
export const isEmisionCompleted = (status: EmisionStatus): boolean => {
  return completedEmisionStatus.includes(status);
};

// Función helper para verificar si un estatus indica que la emisión ha finalizado correctamente
export const isEmisionFinished = (status: EmisionStatus): boolean => {
  return finishedEmisionStatus.includes(status);
};

// Función helper para verificar si un estatus indica éxito
export const isEmisionSuccessful = (status: EmisionStatus): boolean => {
  return successEmisionStatus.includes(status);
};

// Función helper para verificar si un estatus indica error
export const isEmisionError = (status: EmisionStatus): boolean => {
  return errorEmisionStatus.includes(status);
};

// Función helper para obtener el estado de un estatus
export const getEmisionState = (status: EmisionStatus): EmisionState => {
  return emisionStates[status];
};

/**
 * Verifica si un estatus permite continuar en el punto Aserta
 * @param status Estatus de la emisión
 * @returns Verdadero si puede continuar, falso en caso contrario
 */
export const isContinueInPuntoAserta = (status: EmisionStatus): boolean => {
  return continueInPuntoAsertaStatus.includes(status);
}

export const isEditableStatus = (status: EmisionStatus): boolean => {
  return editableEmisionStatus.includes(status);
};

export const validToDelete = (status: EmisionStatus): boolean => {
  return !isEmisionFinished(status);
};

export const canControlChange = (status: EmisionStatus): boolean => {
  return controlChangeEmisionStatus.includes(status);
}

const routesByEstatus: Partial<Record<EmisionStatus, string>> = {
  [EmisionStatus.IN_VALIDATION_PROCESS]: "/emission/policy/{idCliente}/sourceDocument?idEmission={idEmission}",
  [EmisionStatus.EMISSION_TEXT_VALIDATION]: "/emission/policy/{idCliente}/risks-and-wording?idEmission={idEmission}",
  [EmisionStatus.EMISSION_PREVIEW_VALIDATION]: "/emission/policy/{idCliente}/prevalidate?idEmission={idEmission}",
  [EmisionStatus.EMISSION_VALIDATING_AUTHORIZATIONS]: "/emission/policy/{idCliente}/prevalidate?idEmission={idEmission}",
  [EmisionStatus.EMISSION_FINISHED]: "/emission/policy/{idCliente}/preview?idEmission={idEmission}",
}

export const getRouteByEstatus = (status: EmisionStatus, idCliente: string, idEmission: string): string => {
  console.log("getRouteByEstatus", status, idCliente, idEmission);
  const route = routesByEstatus[status];

  if (!route) {
    return "";
  }

  return route.replace("{idCliente}", idCliente).replace("{idEmission}", idEmission);
};